/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import NProgress from 'nprogress'
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import SegmentationAction from '../../action/segmentation'
import EditView from '../../view/pages/segmentation/EditView'
import SegmentCategoryStore from '../../store/segmentation/SegmentCategoryStore'
import SegmentValuesStore from '../../store/segmentation/SegmentValuesStore'

class EditContainer extends Component {
  static getStores() {
    return [SegmentCategoryStore, SegmentValuesStore]
  }

  static calculateState(prevState, props) {
    return {
      segment_category: SegmentCategoryStore.getState(),
      segment_values: SegmentValuesStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()
    const id = this.state.match.params.id
    if (id) {
      await SegmentationAction.fetchOne(id)
    }
    NProgress.done()
  }

  render() {
    return EditView(this.state)
  }
}

export default withRouter(Container.create(EditContainer, { withProps: true }))
